import { createWebHistory, createRouter } from "vue-router";
import { getCookie } from "@/utils/cookie";

const routes = [
  {
    path: "/",
    name: "LoginPage",
    component: () => import("@/views/auth/LoginPage.vue"),
    meta: { unauthorized: true },
  },
  {
    path: "/medical",
    name: "MedicalPage",
    component: () => import("@/views/medical/index.vue"),
  },
  {
    path: "/addMedical",
    name: "AddMedicalPage",
    component: () => import("@/views/medical/AddMedical.vue"),
  },
  {
    path: "/medicalUpdate",
    name: "MedicalUpdatePage",
    component: () => import("@/views/medical/MedicalUpdate.vue"),
  },
  {
    path: "/patient",
    name: "PatientPage",
    component: () => import("@/views/patient/index.vue"),
  },
  {
    path: "/patientDetail/:id",
    name: "PatientDetailPage",
    component: () => import("@/views/patient/PatientDetail.vue"),
  },
  {
    path: "/patientUpdate",
    name: "PatientUpdatePage",
    component: () => import("@/views/patient/PatientUpdate.vue"),
  },
  {
    path: "/addPatient",
    name: "AddPatientPage",
    component: () => import("@/views/patient/AddPatient.vue"),
  },
  {
    path: "/dressing",
    name: "DressingPage",
    component: () => import("@/views/dressing/index.vue"),
  },
  {
    path: "/log",
    name: "LogPage",
    component: () => import("@/views/log/LogPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach(async (to, from, next) => {
  if (getCookie("token")) {
    // console.log(getCookie('token'))
    if (to.meta.unauthorized) {
      // console.log('권한 필요한 경로', to.path)
      sessionStorage.setItem("pathToLoadUnAuth", to.path);
      sessionStorage.setItem("pathFromLoadUnAuth", from.path);
      // console.log('권한 필요한 경로', to.path)
      return next("/medical");
    } else {
      // console.log('권한 필요없는 경로', to.path)
      sessionStorage.setItem("pathToLoadAuth", to.path);
      sessionStorage.setItem("pathFromLoadAuth", from.path);
      // console.log('권한 필요없는 경로', to.path)
      // console.log('token 있으면서 false 일경우 지나갑니다.')
      return next();
    }
  } else {
    // console.log('token이 없는 상태')
    if (to.meta.unauthorized) {
      // console.log('권한 필요한', to.path)
      sessionStorage.setItem("pathToLoadAuth", to.path);
      sessionStorage.setItem("pathFromLoadAuth", from.path);
      // console.log('권한 필요한', to.path)
      // console.log('token 없으면서 true 일경우 지나갑니다.')
      return next();
    } else {
      // console.log('4')
      // console.log('token이 없으면서 unauthorized가 false일때')
      // console.log('--------------------------------------------------')
      // console.log(
      //   'router의 index.js에서 확인합니다 2-3 > getCookie(token)값 ↓ '
      // )
      // console.log(getCookie('token'))
      // console.log('--------------------------------------------------')
      // console.log('권한 필요없는 경로', to.path)
      sessionStorage.setItem("pathToLoadUnAuth", to.path);
      sessionStorage.setItem("pathFromLoadUnAuth", from.path);
      // console.log('권한 필요없는 경로', to.path)
      // console.log('token 없으면서 false 일경우 지나갑니다.')
      return next("/");
    }
  }
});

export default router;
